import * as React from 'react';
import PropTypes from 'prop-types';

const ContactInformation = ({ styles }) => (<div style={styles}>
  <h2 style={styles.h2}>Stužák, z.s.</h2>
  U Lužického semináře 101/26<br />118 00 Praha 1
  <h3 style={styles.h3}>IČO</h3>06536832
  <h3 style={styles.h3}>DIČ</h3>CZ06536832
  <h3 style={styles.h3}>Transparentní účet</h3>
  <a href="https://www.fio.cz/ib2/transparent?a=2501324053" rel="noopener noreferrer" style={styles.link} target="_blank">2501324053/2010</a>
</div>);

ContactInformation.propTypes = {
  styles: PropTypes.shape.isRequired
};

export default ContactInformation;



// WEBPACK FOOTER //
// ./src/browser/Feature/components/contact_information.jsx